import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { checkAuthenticated } from "../actions/auth";
import { useDispatch } from "react-redux";

const DocumentList = ({ personId, documentListConfig }) => {
  const dispatch = useDispatch();
  const { deleteFunction, uploadFunction, loadFunction } = documentListConfig;
  const [pendingFile, setPendingFile] = useState({
    name: "",
    file: null,
  });
  const [files, setFiles] = useState([]);

  const downloadFile = (file) => {
    const url = `${process.env.REACT_APP_API_URL}${file.file}`;
    const link = document.createElement("a");
    link.href = url;
    const filename = url.substring(url.lastIndexOf("/") + 1);

    link.download = filename;
    link.target = "_blank";
    link.click();
  };

  const fetchFiles = async () => {
    const data = await loadFunction(personId);
    if (data) {
      setFiles(data.results);
    }
  };
  const handleDelete = async (file_id) => {
    dispatch(checkAuthenticated());
    await deleteFunction(personId, file_id);
    fetchFiles();
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPendingFile({
        name: file.name,
        file: file,
      });
    }
  };
  const handleUpload = async () => {
    if (pendingFile.file) {
      dispatch(checkAuthenticated());
      const result = await uploadFunction(personId, pendingFile.file);
      if (result) {
        fetchFiles();
        setPendingFile({
          name: "",
          file: null,
        });
      }
    } else {
      console.log("No file selected");
    }
  };
  useEffect(() => {
    fetchFiles();
  }, [loadFunction]);

  return (
    <div className="document-list-section">
      <div className="list-header d-flex justify-content-between">
        <h4>Documentos</h4>
      </div>
      <div className="mb-3 d-flex flex-wrap justify-content-evenly gap-2">
        <div className="w-100">
          <label htmlFor="formFile" className="form-label">
            Nuevo Archivo
          </label>
          <div className="file-input-group input-group">
            <input
              className="form-control d-none"
              type="file"
              id="inputGroupFile"
              onChange={handleFileChange}
            />
            <div className="d-flex align-items-center flex-fill p-2">
              <span className="badge text-bg-secondary">
                {pendingFile.name}
              </span>
            </div>
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={() => document.getElementById("inputGroupFile").click()}
            >
              Seleccionar Archivo
            </button>
          </div>
        </div>

        <div className="add-button">
          <Button
            variant="outline-primary d-flex align-items-center gap-2"
            onClick={() => handleUpload()}
          >
            Subir Archivo
          </Button>
        </div>
      </div>
      <div className="document-list">
        {files.map((file, index) => (
          <div className="file-item" key={file.id}>
            <div className="file-item-title">
              <h5 title={file.filename}>{file.filename}</h5>
            </div>
            <div className="file-item-actions">
              <Button
                variant="outline-primary d-flex align-items-center gap-2"
                onClick={() => downloadFile(file)}
              >
                <i className="bi bi-download" />
              </Button>
              <Button
                variant="outline-primary d-flex align-items-center gap-2"
                onClick={() => handleDelete(file.id)}
              >
                <i className="bi bi-trash" />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DocumentList;
